/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemDiscountReportDTO,
  ItemDiscountReportDTOOptional,
  ItemDiscountReportDTOMetaI,
  ItemDiscountReportDTOTrackedI,
} from "./item-discount-report-dto";
import {
  ItemDiscountReportDTOTracked,
  ItemDiscountReportDTOMeta,
} from "./item-discount-report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemBase,
  LineItemBaseOptional,
  LineItemBaseMetaI,
  LineItemBaseTrackedI,
} from "./line-item-base";
import { LineItemBaseTracked, LineItemBaseMeta } from "./line-item-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  LineItemRef,
  LineItemRefOptional,
  LineItemRefMetaI,
  LineItemRefTrackedI,
} from "./line-item-ref";
import { LineItemRefTracked, LineItemRefMeta } from "./line-item-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";

/**
 *
 * @export
 * @interface OrderItemReportDTO
 */
export interface OrderItemReportDTOOptional extends LineItemBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderItemReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderItemReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof OrderItemReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof OrderItemReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof OrderItemReportDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof OrderItemReportDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof OrderItemReportDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountBaseCents?: number;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountSpecifiedCents?: number;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountPaidCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountTotalCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrderItemReportDTO
   */
  autoAdded?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  squareLineItemUid?: string;
  /**
   *
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  referenceId?: string;
  /**
   *
   * @type {Array<ItemDiscountReportDTO>}
   * @memberof OrderItemReportDTO
   */
  discountReports?: ItemDiscountReportDTOOptional[];
}

export interface OrderItemReportDTO
  extends OrderItemReportDTOOptional, LineItemBase, LineItemRef, ReportDTO {
  /**
   *
   * @type {boolean}
   * @memberof OrderItemReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderItemReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof OrderItemReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof OrderItemReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof OrderItemReportDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof OrderItemReportDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof OrderItemReportDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountBaseCents: number;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountSpecifiedCents?: number;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountPaidCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountSubtotalCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountTotalCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof OrderItemReportDTO
   */
  autoAdded?: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  squareLineItemUid?: string;
  /**
   *
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  referenceId?: string;
  /**
   *
   * @type {Array<ItemDiscountReportDTO>}
   * @memberof OrderItemReportDTO
   */
  discountReports?: ItemDiscountReportDTO[];
}

export interface OrderItemReportDTOTrackedI extends LineItemBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof OrderItemReportDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderItemReportDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof OrderItemReportDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof OrderItemReportDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof OrderItemReportDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof OrderItemReportDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof OrderItemReportDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountBaseCents?: number;
  amountBaseCentsIsSet: boolean;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountSpecifiedCents?: number;
  amountSpecifiedCentsIsSet: boolean;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountSubtotalCents?: number;
  amountSubtotalCentsIsSet: boolean;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OrderItemReportDTO
   */
  autoAdded?: boolean;
  autoAddedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  squareLineItemUid?: string;
  squareLineItemUidIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof OrderItemReportDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OrderItemReportDTO
   */
  referenceId?: string;
  referenceIdIsSet: boolean;
  /**
   *
   * @type {Array<ItemDiscountReportDTO>}
   * @memberof OrderItemReportDTO
   */
  discountReports?: ItemDiscountReportDTOTrackedI[];
  discountReportsIsSet: boolean;
}

transformDatesMap.set(
  "OrderItemReportDTO",
  function (model: OrderItemReportDTO) {
    const transformDateschildReports = transformDatesMap.get("ReportDTO");
    if (transformDateschildReports) {
      model.childReports?.forEach((sub) => {
        transformDateschildReports(sub);
      });
    }
    const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
    if (transformDatesmeta) {
      model.meta?.forEach((sub) => {
        transformDatesmeta(sub);
      });
    }
    const transformDatestypeCounts =
      transformDatesMap.get("ReportTypeCountDTO");
    if (transformDatestypeCounts) {
      model.typeCounts?.forEach((sub) => {
        transformDatestypeCounts(sub);
      });
    }
    const transformDatesdiscountReports = transformDatesMap.get(
      "ItemDiscountReportDTO",
    );
    if (transformDatesdiscountReports) {
      model.discountReports?.forEach((sub) => {
        transformDatesdiscountReports(sub);
      });
    }
  },
);

export type OrderItemReportDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  amountBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountSpecifiedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountSubtotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  autoAdded: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  squareLineItemUid: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  referenceId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  discountReports: PropertyMeta<ItemDiscountReportDTOMetaI>;
}>;

export var OrderItemReportDTOMeta: OrderItemReportDTOMetaI =
  {} as OrderItemReportDTOMetaI;
OrderItemReportDTOMeta = typeMeta("OrderItemReportDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
  amountBaseCents: propertyMeta(
    "amountBaseCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  amountSpecifiedCents: propertyMeta(
    "amountSpecifiedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountSubtotalCents: propertyMeta(
    "amountSubtotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  autoAdded: propertyMeta(
    "autoAdded",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  squareLineItemUid: propertyMeta(
    "squareLineItemUid",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  referenceId: propertyMeta(
    "referenceId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  discountReports: propertyMeta(
    "discountReports",
    true,
    false,
    false,
    ItemDiscountReportDTOMeta,
  ),
});

const metaI = OrderItemReportDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([ReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = ReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = ReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = ReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = ReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = ReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = ReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = ReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = ReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = ReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = ReportDTOMeta.typeCounts;
  metaI.interfaces = metaI.interfaces.concat([LineItemBaseMeta]);
  metaI.amountBaseCents.inheritedFrom = LineItemBaseMeta.amountBaseCents;
  metaI.amountSpecifiedCents.inheritedFrom =
    LineItemBaseMeta.amountSpecifiedCents;
  metaI.amountPaidCents.inheritedFrom = LineItemBaseMeta.amountPaidCents;
  metaI.amountSubtotalCents.inheritedFrom =
    LineItemBaseMeta.amountSubtotalCents;
  metaI.amountTotalCents.inheritedFrom = LineItemBaseMeta.amountTotalCents;
  metaI.autoAdded.inheritedFrom = LineItemBaseMeta.autoAdded;
  metaI.squareLineItemUid.inheritedFrom = LineItemBaseMeta.squareLineItemUid;
  metaI.interfaces = metaI.interfaces.concat([LineItemRefMeta]);
  metaI.assignId.inheritedFrom = LineItemRefMeta.assignId;
  metaI.referenceId.inheritedFrom = LineItemRefMeta.referenceId;
});

export class OrderItemReportDTOTracked
  extends LineItemBaseTracked
  implements OrderItemReportDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  amountBaseCents__I?: number = undefined;
  amountBaseCentsIsSet: boolean = false;
  set amountBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountBaseCents__I = v;
      this.amountBaseCentsIsSet = true;
    } else {
      this.amountBaseCents__I = v || undefined;
      this.amountBaseCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get amountBaseCents() {
    return this.amountBaseCents__I;
  }
  amountSpecifiedCents__I?: number = undefined;
  amountSpecifiedCentsIsSet: boolean = false;
  set amountSpecifiedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSpecifiedCents__I = v;
      this.amountSpecifiedCentsIsSet = true;
    } else {
      this.amountSpecifiedCents__I = v || undefined;
      this.amountSpecifiedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSpecifiedCents() {
    return this.amountSpecifiedCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  amountSubtotalCents__I?: number = undefined;
  amountSubtotalCentsIsSet: boolean = false;
  set amountSubtotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSubtotalCents__I = v;
      this.amountSubtotalCentsIsSet = true;
    } else {
      this.amountSubtotalCents__I = v || undefined;
      this.amountSubtotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSubtotalCents() {
    return this.amountSubtotalCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  autoAdded__I?: boolean = undefined;
  autoAddedIsSet: boolean = false;
  set autoAdded(v: undefined | boolean) {
    if (v !== undefined) {
      this.autoAdded__I = v;
      this.autoAddedIsSet = true;
    } else {
      this.autoAdded__I = v || undefined;
      this.autoAddedIsSet = false;
    }
    this.changeTracker = true;
  }
  get autoAdded() {
    return this.autoAdded__I;
  }
  squareLineItemUid__I?: string = undefined;
  squareLineItemUidIsSet: boolean = false;
  set squareLineItemUid(v: undefined | string) {
    if (v !== undefined) {
      this.squareLineItemUid__I = v;
      this.squareLineItemUidIsSet = true;
    } else {
      this.squareLineItemUid__I = v || undefined;
      this.squareLineItemUidIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareLineItemUid() {
    return this.squareLineItemUid__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  referenceId__I?: string = undefined;
  referenceIdIsSet: boolean = false;
  set referenceId(v: undefined | string) {
    if (v !== undefined) {
      this.referenceId__I = v;
      this.referenceIdIsSet = true;
    } else {
      this.referenceId__I = v || undefined;
      this.referenceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get referenceId() {
    return this.referenceId__I;
  }
  discountReports__I?: ItemDiscountReportDTOTracked[] = undefined;
  discountReportsIsSet: boolean = false;
  set discountReports(v: undefined | ItemDiscountReportDTOTracked[]) {
    if (v !== undefined) {
      this.discountReports__I = v;
      this.discountReportsIsSet = true;
    } else {
      this.discountReports__I = v || undefined;
      this.discountReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get discountReports() {
    return this.discountReports__I;
  }
  constructor(config?: OrderItemReportDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.referenceIdIsSet == true && other?.referenceIdIsSet == true)
      return this.referenceId == other.referenceId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());

    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.discountReports?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: OrderItemReportDTOOptional,
    options?: AssignOptions,
  ): OrderItemReportDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (
      config.amountBaseCents &&
      this.amountBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountBaseCents = config.amountBaseCents;
      if (optionsRequired.unassign) this.amountBaseCentsIsSet = false;
      else this.amountBaseCentsIsSet = true;
    }
    if (
      config.amountSpecifiedCents &&
      this.amountSpecifiedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSpecifiedCents = config.amountSpecifiedCents;
      if (optionsRequired.unassign) this.amountSpecifiedCentsIsSet = false;
      else this.amountSpecifiedCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (
      config.amountSubtotalCents &&
      this.amountSubtotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSubtotalCents = config.amountSubtotalCents;
      if (optionsRequired.unassign) this.amountSubtotalCentsIsSet = false;
      else this.amountSubtotalCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (config.autoAdded && this.autoAddedApplyFilter(optionsRequired.filter)) {
      this.autoAdded = config.autoAdded;
      if (optionsRequired.unassign) this.autoAddedIsSet = false;
      else this.autoAddedIsSet = true;
    }
    if (
      config.squareLineItemUid &&
      this.squareLineItemUidApplyFilter(optionsRequired.filter)
    ) {
      this.squareLineItemUid = config.squareLineItemUid;
      if (optionsRequired.unassign) this.squareLineItemUidIsSet = false;
      else this.squareLineItemUidIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.referenceId &&
      this.referenceIdApplyFilter(optionsRequired.filter)
    ) {
      this.referenceId = config.referenceId;
      if (optionsRequired.unassign) this.referenceIdIsSet = false;
      else this.referenceIdIsSet = true;
    }
    if (
      config.discountReports &&
      this.discountReportsApplyFilter(optionsRequired.filter)
    ) {
      this.discountReports = config.discountReports?.map(
        (a) => new ItemDiscountReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.discountReportsIsSet = false;
      else this.discountReportsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderItemReportDTOTrackedI {
    const cloned = {} as OrderItemReportDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.amountBaseCentsIsSetDeep() &&
      this.amountBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountBaseCentsIsSet = true;
      cloned.amountBaseCents = this.amountBaseCents;
    } else {
      //cloned.amountBaseCentsIsSet = false
    }
    if (
      this.amountSpecifiedCentsIsSetDeep() &&
      this.amountSpecifiedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSpecifiedCentsIsSet = true;
      cloned.amountSpecifiedCents = this.amountSpecifiedCents;
    } else {
      //cloned.amountSpecifiedCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.amountSubtotalCentsIsSetDeep() &&
      this.amountSubtotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSubtotalCentsIsSet = true;
      cloned.amountSubtotalCents = this.amountSubtotalCents;
    } else {
      //cloned.amountSubtotalCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.autoAddedIsSetDeep() &&
      this.autoAddedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.autoAddedIsSet = true;
      cloned.autoAdded = this.autoAdded;
    } else {
      //cloned.autoAddedIsSet = false
    }
    if (
      this.squareLineItemUidIsSetDeep() &&
      this.squareLineItemUidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareLineItemUidIsSet = true;
      cloned.squareLineItemUid = this.squareLineItemUid;
    } else {
      //cloned.squareLineItemUidIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.referenceIdIsSetDeep() &&
      this.referenceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referenceIdIsSet = true;
      cloned.referenceId = this.referenceId;
    } else {
      //cloned.referenceIdIsSet = false
    }
    if (
      this.discountReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.discountReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountReportsIsSet = true;
      cloned.discountReports = this.discountReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.discountReportsIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderItemReportDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.amountBaseCentsApplyFilter(filter))
      this.amountBaseCentsIsSet = false;

    if (!this.amountSpecifiedCentsApplyFilter(filter))
      this.amountSpecifiedCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.amountSubtotalCentsApplyFilter(filter))
      this.amountSubtotalCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.autoAddedApplyFilter(filter)) this.autoAddedIsSet = false;

    if (!this.squareLineItemUidApplyFilter(filter))
      this.squareLineItemUidIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.referenceIdApplyFilter(filter)) this.referenceIdIsSet = false;

    if (!this.discountReportsApplyFilter(filter))
      this.discountReportsIsSet = false;

    this.discountReports?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.isDeleted,
      OrderItemReportDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.isNew,
      OrderItemReportDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.reportId,
      OrderItemReportDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.reportKey,
      OrderItemReportDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.reportTitle,
      OrderItemReportDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.reportType,
      OrderItemReportDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.reportStatus,
      OrderItemReportDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.childReports,
      OrderItemReportDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.meta,
      OrderItemReportDTOMeta,
      this.meta,
      this,
    );
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.typeCounts,
      OrderItemReportDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  amountBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.amountBaseCents,
      OrderItemReportDTOMeta,
      this.amountBaseCents,
      this,
    );
  }
  amountBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountBaseCentsIsSet && this.amountBaseCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountSpecifiedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.amountSpecifiedCents,
      OrderItemReportDTOMeta,
      this.amountSpecifiedCents,
      this,
    );
  }
  amountSpecifiedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSpecifiedCentsIsSet &&
      this.amountSpecifiedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.amountPaidCents,
      OrderItemReportDTOMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountSubtotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.amountSubtotalCents,
      OrderItemReportDTOMeta,
      this.amountSubtotalCents,
      this,
    );
  }
  amountSubtotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSubtotalCentsIsSet &&
      this.amountSubtotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.amountTotalCents,
      OrderItemReportDTOMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  autoAddedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.autoAdded,
      OrderItemReportDTOMeta,
      this.autoAdded,
      this,
    );
  }
  autoAddedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.autoAddedIsSet && this.autoAddedApplyFilter(filter)) return true;

    return false;
  }
  squareLineItemUidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.squareLineItemUid,
      OrderItemReportDTOMeta,
      this.squareLineItemUid,
      this,
    );
  }
  squareLineItemUidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.squareLineItemUidIsSet &&
      this.squareLineItemUidApplyFilter(filter)
    )
      return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.assignId,
      OrderItemReportDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  referenceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.referenceId,
      OrderItemReportDTOMeta,
      this.referenceId,
      this,
    );
  }
  referenceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referenceIdIsSet && this.referenceIdApplyFilter(filter))
      return true;

    return false;
  }
  discountReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderItemReportDTOMeta.discountReports,
      OrderItemReportDTOMeta,
      this.discountReports,
      this,
    );
  }
  discountReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountReportsIsSet && this.discountReportsApplyFilter(filter))
      return true;

    return this.discountReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.amountBaseCentsIsSetDeep(filter)) return true;
    if (this.amountSpecifiedCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.amountSubtotalCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.autoAddedIsSetDeep(filter)) return true;
    if (this.squareLineItemUidIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.referenceIdIsSetDeep(filter)) return true;
    if (this.discountReportsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
